import { getProfissionalLabels } from "./profissionalRotulo";

/**
 * Normaliza lista JSON de rótulos vindos do tipo de estabelecimento.
 */
export const normalizarListaRotulosProfissional = (raw) => {
  if (!raw) return [];
  let lista = raw;
  if (typeof raw === "string") {
    try {
      lista = JSON.parse(raw);
    } catch {
      return [];
    }
  }
  if (!Array.isArray(lista)) return [];

  return [
    ...new Set(
      lista
        .map((item) => {
          if (typeof item === "string") return item.trim().toLowerCase();
          if (item && typeof item === "object") {
            const valor = item.value || item.rotulo || item.label || "";
            return String(valor).trim().toLowerCase();
          }
          return "";
        })
        .filter(Boolean)
    ),
  ];
};

export const montarOpcoesRotuloProfissional = ({
  rotulosDoTipo = [],
  valorAtual = "",
} = {}) => {
  const rotulos = normalizarListaRotulosProfissional(rotulosDoTipo);
  const options = [
    { value: "", label: "Usar padrão do sistema" },
    ...rotulos.map((rotulo) => {
      const labels = getProfissionalLabels({ rotulo_profissional: rotulo });
      return { value: rotulo, label: labels.singular };
    }),
  ];

  const atual = String(valorAtual || "").trim().toLowerCase();
  if (atual && !options.some((opt) => opt.value === atual)) {
    const labels = getProfissionalLabels({ rotulo_profissional: atual });
    options.splice(1, 0, {
      value: atual,
      label: `${labels.singular} (fora da lista)`,
    });
  }

  return options;
};
